import { ReactNode } from 'react';
import { useLogger, useServices } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, FinalizeRequestStepData } from '@packages/shared/core/quiz/entities';

type FinalizeRequestQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const FinalizeRequestQuizStep = ({ id, renderQuizScreen }: FinalizeRequestQuizStepProps) => {
  const logger = useLogger();
  const { analyticsService } = useServices();

  const { back, next, stepData, totalSteps, stepOrder, updateUserPreferences } = useQuizStep(id);

  const finalizeRequestStepData = stepData as FinalizeRequestStepData;
  const { dataKey } = finalizeRequestStepData;

  if (!stepData) {
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const goBack = async () => back();

  const onContinue = (request: string) => {
    updateUserPreferences(dataKey, request);
    next(request);
    if (finalizeRequestStepData.otherEvent) {
      analyticsService.trackQuizEvent(finalizeRequestStepData.otherEvent, {
        value: 'CTA',
        context: request,
      });
    }
  };

  const handleEdit = () => {
    if (finalizeRequestStepData.otherEvent) {
      analyticsService.trackQuizEvent(finalizeRequestStepData.otherEvent, {
        value: 'edit',
      });
    }
  };

  return (
    <>
      {renderQuizScreen({
        onContinue,
        onBack: goBack,
        handleEdit,
        totalSteps,
        stepOrder,
        ...finalizeRequestStepData,
      })}
    </>
  );
};

export default FinalizeRequestQuizStep;
